import React from 'react';
import { Fade, Button } from '@material-ui/core';
import MultiSelectModal from '../../../../components/util/modalDinamica/childrens/modalRadioButton/.mixins/multiSelectModal';
import { ArrowDropDown } from '@material-ui/icons';
import { useFormsContext } from 'pages/forms/context/FormsProvider';

export const FormStatus = () => {
  const {
    handleOptionChange,
    handleOptionClick,
    handleStatusFilterModal,
    isStatusModalOpen,
    selectedStatusOptions,
    selectedOptionsCheckboxes
  } = useFormsContext();

  const headerModal = { title: 'Filtrar formulários por status' };
  const btComponent = { label: 'CONFIRMAR' };

  return (
    <>
      <Button
        variant="contained"
        onClick={handleStatusFilterModal}
        endIcon={<ArrowDropDown />}
        style={{ borderRadius: '20px' }}
      >
        Filtrar formulários por status
      </Button>

      <Fade in={isStatusModalOpen}>
        <MultiSelectModal
          checkedId={selectedOptionsCheckboxes}
          isModalOpen={isStatusModalOpen}
          headerModal={headerModal}
          btComponent={btComponent}
          buttonType="checkbox"
          itensModal={selectedStatusOptions}
          setIdOnChange={handleOptionChange}
          getIdOnClick={handleOptionClick}
          handleDialogModal={handleStatusFilterModal}
        />
      </Fade>
    </>
  );
};
